




import Vue, { PropType } from "vue";
import ice from "../../lib/ice";

export interface BootWithSerialButtonProps {
  serial: string;
}

export default Vue.extend({
  name: "vc-boot-with-serial-button",
  props: {
    serial: {
      type: String as PropType<BootWithSerialButtonProps["serial"]>,
      default: ""
    }
  },
  methods: {
    onClickButton(e: Event) {
      ice.bootWithSerial(this.serial);
      e.preventDefault();
    }
  }
});
